import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RootState } from '@root/app.state';

import { selectContacts, selectNavigatedCustomerSpace } from '@core/core.selectors';
import { Contact, CustomerSpace } from '@core/core.state';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
})
export class ContactsComponent implements OnInit {
  public contacts$!: Observable<Contact[]>;
  public customerSpace$!: Observable<CustomerSpace>;

  constructor(private store$: Store<RootState>) {}

  ngOnInit(): void {
    this.contacts$ = this.store$.pipe(
      select(selectContacts),
      map((state) => state.data),
    );

    this.customerSpace$ = this.store$.pipe(
      select(selectNavigatedCustomerSpace),
      filter((x) => x.data !== null),
      map((x) => x.data),
    );
  }
}
